import { render, staticRenderFns } from "./Privilege.vue?vue&type=template&id=3d7ae27b"
import script from "./Privilege.vue?vue&type=script&lang=js"
export * from "./Privilege.vue?vue&type=script&lang=js"
import style0 from "./Privilege.vue?vue&type=style&index=0&id=3d7ae27b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports